import { render, staticRenderFns } from "./InventoryTableDesktop.vue?vue&type=template&id=480ab6bd&scoped=true&"
import script from "./InventoryTableDesktop.vue?vue&type=script&lang=ts&"
export * from "./InventoryTableDesktop.vue?vue&type=script&lang=ts&"
import style0 from "./InventoryTableDesktop.vue?vue&type=style&index=0&id=480ab6bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ab6bd",
  null
  
)

export default component.exports